import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ReportService } from 'src/app/service/report.service';
import { meeting_dataSources, task_dataSources } from 'src/app/mock';
import { event } from 'jquery';


interface Meeting {
  MEETING_DATE: string;
  MEETING_TITLE: string;
  FACILITATOR: string;
}

@Component({
  selector: 'app-drill-down-preview',
  templateUrl: './drill-down-preview.component.html',
  styleUrl: './drill-down-preview.component.css'
})
export class DrillDownPreviewComponent {
  meetings: any[] = [
    { MEETING_DATE: "01/02/2025 00:00:00", MEETING_TITLE: "Test Meeting", FACILITATOR: "Ramya Raja" },
    { MEETING_DATE: "01/02/2025 00:00:00", MEETING_TITLE: "Test Meeting notes", FACILITATOR: "Ramya Raja" },
    { MEETING_DATE: "01/03/2025 00:00:00", MEETING_TITLE: "User max rights", FACILITATOR: "Saranraj M w" },
    { MEETING_DATE: "01/03/2025 00:00:00", MEETING_TITLE: "New task Meeting", FACILITATOR: "Srikanth Talari" },
    { MEETING_DATE: "01/04/2025 00:00:00", MEETING_TITLE: "Project Update", FACILITATOR: "John Doe" },
    { MEETING_DATE: "01/04/2025 00:00:00", MEETING_TITLE: "Client Call", FACILITATOR: "Jane Smith" },
  ];
  dataSource: any;
  groupedMeetings: { date: string, meetings: Meeting[] }[] = [];
  itemsPerPageArr = [5, 10, 20, 30];
  totalItems = 0;
  req: any;
  noData = true;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(private router: Router, @Inject(MAT_DIALOG_DATA) data: any, private dialogRef: MatDialogRef<DrillDownPreviewComponent>, private reportService: ReportService) {
    if (data['dataSource'] == 'meeting') {
      this.dataSource = meeting_dataSources;
    }
    else {
      this.dataSource = task_dataSources;
    }
    // this.meetings = data['dataSource'];
    this.req = data['req']
    //this.dataSource.data=this.meetings;
    // this.dataSource = data['dataSource'];
    this.reportService.getDrilldownData(this.req).subscribe((data: any) => {
    })
  }

  ngOnInit() {
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
  }

  closeDialog() {
    this.dialogRef.close();
  }
  openMeeting(meeting: any) {
    this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meeting.MEETING_ID, "isMeetingRunning": true, "zoomMeetingId": meeting.zoomMeetingId, "zoomPassword": meeting.zoomPassword }) }, skipLocationChange: true, replaceUrl: false });
    this.dialogRef.close();
  }


  pageChange(event: any) {
    this.req.rows = 10;
    if (event != 1)
      this.req.start = (event - 1) * this.req.rows + 1;
    else
      this.req.start = 1;

    this.dataSource =
    {
      ...this.dataSource,
      data: []
    }
    this.reportService.getDrilldownData(this.req).subscribe((data: any) => {
      if (data.body.response.RESULT.ROWSET.ROW.length != 0) {
        this.noData = false;
        this.dataSource =
        {
          ...this.dataSource,
          data: data.body.response.RESULT.ROWSET.ROW
        }
        this.totalItems = data.body.response.RESULT.METADATA.TOTAL_RECORD_COUNT;
      }
      else {
        this.noData = true;

      }
    })

  }


  globalSearch(event: any) {
    if (event == 'meeting') {
      this.req.start = 1;
      this.req.gridDrillArr.push = {
        "colAlias": "",
        "condition": "~INCLUDES~",
        "operator": "OR",
        "startBrace": "(",
        "endBrace": ")",
        "conditionValue": "saran",
        "conditionType": "",
        "conditionCategory": "",
        "conditionConstant": ""
      }
    }
    else {

    }
  }

  itemsPerPageChange(event: any) {
    console.log("items per page : ", event)
  }

  columnSearch(event: any) {
    console.log("hello : ", event)
  }






}
